import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  TabPanel,
  Tag,
  TagLabel,
  TagRightIcon,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import { TbListDetails } from 'react-icons/tb';
import { TfiReload } from 'react-icons/tfi';
import { R$ } from 'shared/helpers/currency';
import { DeliveryOrder } from 'shared/models/deliveryOrder';
import { DeliveryOrderStatus } from 'shared/types/deliveryOrder';
import { useDeliveryContext } from '../DeliveryContext';
import PaymentDetailsModal from './PaymentDetailsModal';

const OrderHistory = () => {
  const { orders, changeOrderStatus, statusLabels, getVerifyOrderPayment } =
    useDeliveryContext();
  const [detailedOrder, setDetailedOrder] = useState<DeliveryOrder>();

  const onCloseDetails = () => setDetailedOrder(undefined);

  return (
    <TabPanel>
      <PaymentDetailsModal order={detailedOrder} onClose={onCloseDetails} />
      {orders.length ? (
        <TableContainer>
          <Table size="sm">
            <Thead>
              <Tr h="3.5rem">
                <Th whiteSpace="break-spaces" textAlign="center">
                  N°. do pedido
                </Th>
                <Th whiteSpace="break-spaces" textAlign="center">
                  Nome do cliente
                </Th>
                <Th whiteSpace="break-spaces" textAlign="center">
                  Data e hora
                </Th>
                <Th whiteSpace="break-spaces" textAlign="center">
                  Última atualização
                </Th>
                <Th textAlign="center">Valor</Th>
                <Th whiteSpace="break-spaces" textAlign="center">
                  Origem
                </Th>
                <Th whiteSpace="break-spaces" textAlign="center">
                  Status do pedido
                </Th>
                <Th whiteSpace="break-spaces" textAlign="center">
                  Recarregar
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {orders.map((order) => (
                <Tr key={order.id} h="3.5rem">
                  <Td>{order.id}</Td>
                  <Td whiteSpace="break-spaces" textAlign="center">
                    {order.customerName}
                  </Td>
                  <Td whiteSpace="break-spaces" textAlign="center">
                    {order.createdAt.format('DD/MM/YYYY hh:mm')}
                  </Td>
                  <Td whiteSpace="break-spaces" textAlign="center">
                    {order.updatedAt.format('DD/MM/YYYY hh:mm')}
                  </Td>
                  <Td isNumeric>
                    <Button
                      onClick={() => setDetailedOrder(order)}
                      size="sm"
                      variant="link"
                      rightIcon={<TbListDetails />}
                    >
                      {R$(order.price)?.replace(' ', '')}
                    </Button>
                  </Td>
                  <Td whiteSpace="break-spaces" textAlign="center">
                    {order.origin}
                  </Td>
                  <Td isNumeric>
                    <Menu matchWidth>
                      <MenuButton w="100%">
                        <Tag
                          size="sm"
                          colorScheme={
                            order.status === 'FINISHED'
                              ? 'green'
                              : order.status === 'CANCELLED'
                                ? 'red'
                                : 'yellow'
                          }
                        >
                          <TagLabel>{statusLabels[order.status]}</TagLabel>
                          <TagRightIcon as={FaChevronDown} />
                        </Tag>
                      </MenuButton>
                      <MenuList minW="0">
                        {Object.keys(statusLabels).map(
                          (status) =>
                            order.status !== status && (
                              <MenuItem
                                key={status}
                                onClick={() =>
                                  changeOrderStatus(
                                    order,
                                    status as DeliveryOrderStatus,
                                  )
                                }
                              >
                                {statusLabels[status]}
                              </MenuItem>
                            ),
                        )}
                      </MenuList>
                    </Menu>
                  </Td>
                  {order.onlinePayments[0].zoop_order_id ? (
                    <Td whiteSpace="break-spaces">
                      <Button
                        onClick={() =>
                          getVerifyOrderPayment(
                            order.onlinePayments[0].zoop_order_id,
                          )
                        }
                        size="sm"
                        variant="link"
                        w="100%"
                        rightIcon={<TfiReload />}
                      ></Button>
                    </Td>
                  ) : (
                    <Tr>
                      <Td whiteSpace="break-spaces" textAlign="center">
                        Sem pagamento online
                      </Td>
                    </Tr>
                  )}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Text>Nenhum pedido encontrado.</Text>
      )}
    </TabPanel>
  );
};

export default OrderHistory;
